import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AppsListItem from './AppsListItem';
import { withRouter } from '../../../withRouter';

function RenderApps(props) {
    const keyPrefix = props.keyPrefix || '';

    return props.apps.map((app) => {
        // Drilling down props instead of using connect and router on the AppListItem component saves 80% of rendering time
        const drillDownProps = {
            history: props.history,
            appGroups: app.groups || [],
            userExists: props.user.exists,
            actsAsAdmin: props.user.actsAsAdmin,
            user: props.user,
            ...app,
        };

        return <AppsListItem key={keyPrefix + app.appId} {...drillDownProps} />;
    });
}
RenderApps.propTypes = {
    apps: PropTypes.array,
    keyPrefix: PropTypes.string,
    history: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({ user: state.user });

export default withRouter(connect(mapStateToProps)(RenderApps));
